import { ViewType } from "../../gd/const/views/view-type";
import { PROJECT_BOARD_CONFIG } from "../../views/board/@config";
import { PROJECT_LIST_CONFIG } from "../../views/list/@config";
import { PROJECT_TABLE_CONFIG } from "../../views/table/@config";


export const AddView_TaskList = {
    typeId          : ViewType.PROJECT_LIST,
    iconSvg         : PROJECT_LIST_CONFIG.iconSvg,
    title           : PROJECT_LIST_CONFIG.menuName,
    description     : PROJECT_LIST_CONFIG.description,
}

export const AddView_TaskTable = {
    typeId          : ViewType.PROJECT_TABLE,
    iconSvg         : PROJECT_TABLE_CONFIG.iconSvg,
    title           : PROJECT_TABLE_CONFIG.menuName,
    description     : PROJECT_TABLE_CONFIG.description,
}

export const AddView_TaskBoard = {
    typeId          : ViewType.PROJECT_BOARD,
    iconSvg         : PROJECT_BOARD_CONFIG.iconSvg,
    title           : PROJECT_BOARD_CONFIG.menuName,
    description     : PROJECT_BOARD_CONFIG.description,
}